/* @jsx jsx */
import React from 'react';
import {jsx} from '@emotion/react';
import {Link} from 'gatsby';

const ReferenceLink = (link) => (<Link to={`/${link.slug.current}/`}>{link.title}</Link>) ;
export default ReferenceLink;
